<div class="content-blk">
<div class="edit-master-product-container">
  <!-- Header -->
  <div class="page-header">
    <button mat-icon-button (click)="goBack()" class="back-button">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="header-content">
      <h2>Edit Product</h2>
      <p class="header-subtitle">Review your product details and continue to update colors, pricing & tags</p>
      <div class="mt-1" *ngIf="decorationSizeLines.length">
        <div class="small" style="color: #6c757d;" *ngFor="let line of decorationSizeLines">
          <strong>Decoration</strong> {{ line }}
        </div>
      </div>
    </div>
  </div>

  <!-- Design Preview Summary -->
  <div class="progress-summary" *ngIf="designData">
    <div class="summary-card">
      <div class="summary-icon">
        <img [src]="designData.previewUrl || designData.designUrl" alt="Design" class="design-thumb-img" *ngIf="designData.previewUrl || designData.designUrl">
        <i class="fa fa-paint-brush" *ngIf="!designData.previewUrl && !designData.designUrl"></i>
      </div>
      <div class="summary-content">
        <h4>Current Design</h4>
        <p>{{ editProductData?.productDetails?.Name || 'Product Design' }}</p>
      </div>
      <div class="summary-count" *ngIf="product">
        <div class="count-badge">1</div>
        <span>Product</span>
      </div>
    </div>
  </div>

  <!-- Products List -->
  <div class="products-list" *ngIf="product">
    <div class="product-card">
      <!-- Product Header -->
      <div class="product-header">
        <div class="product-info">
          <img [src]="productCurrentImage" alt="{{product.Description}}" class="product-thumbnail">
          <div class="product-details">
             <h3 class="mt-1">
                    Description:
                    <small [innerHTML]="product.Description"></small>
                  </h3>
            <p class="product-category">{{ product.CustomizationType }}</p>
          </div>
        </div>
        <div class="product-status">
          <span class="status-badge selected">
            <i class="fa fa-check-circle"></i> Selected for Editing
          </span>
        </div>
      </div>

      <!-- Product Body -->
      <div class="product-body">
        <div class="row">
          <!-- Product Image -->
          <div class="col-md-5">
            <div class="product-image-section">
              <div class="main-image-container">
                <img [src]="productCurrentImage" alt="{{product.Description}}" class="main-product-image"
                     [class.loading-dim]="isLoadingPreview" (load)="onImageLoaded()">
                <div class="preview-loader" *ngIf="isLoadingPreview">
                  <i class="fa fa-spinner fa-spin fa-2x"></i>
                </div>
              </div>
              <!-- Thumbnail images per side -->
              <div class="thumbnail-row" *ngIf="productImageList.length > 0">
                <div class="thumbnail-item"
                     *ngFor="let item of productImageList"
                     [ngClass]="{'active': productCurrentImage === item.url || generatedPreviews.get(selectedStyleId + '_' + item.sideName) === productCurrentImage}"
                     (click)="selectImage(item)">
                  <img [src]="item.url" [alt]="item.sideName">
                  <span class="side-label">{{ item.sideName }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Product Details -->
          <div class="col-md-7">
            <div class="product-info-section">
              <!-- Description -->
              <div class="info-group" *ngIf="longDescription">
                <h4 class="section-title">Description</h4>
                <p class="product-description" [innerHTML]="longDescription"></p>
              </div>

              <!-- Labels -->
              <div class="info-group" *ngIf="productLabels[0]?.text">
                <h4 class="section-title">Labels</h4>
                <div class="labels-list">
                  <ng-container *ngFor="let item of productLabels">
                    <span class="label-badge"
                          [ngStyle]="{'background-color': item.backgroundColor, 'color': item.textColor}"
                          *ngIf="item.text">
                      {{ item.text }}
                    </span>
                  </ng-container>
                </div>
              </div>

              <!-- Tags -->
              <div class="info-group" *ngIf="productTags[0]?.tagtext">
                <h4 class="section-title">Tags</h4>
                <div class="tags-list">
                  <ng-container *ngFor="let item of productTags">
                    <span class="tag-badge" *ngIf="item.tagtext">
                      {{ item.tagtext }}
                    </span>
                  </ng-container>
                </div>
              </div>

              <!-- Sizes -->
              <div class="info-group">
                <h4 class="section-title">Sizes</h4>
                <div class="size-list">
                  <span class="size-tag" *ngFor="let sz of currentSizes">{{ sz.Name }}</span>
                </div>
              </div>

              <!-- Colors -->
              <div class="info-group">
                <h4 class="section-title">Selected Colors</h4>
                <div class="colors-grid">
                  <div *ngFor="let style of selectedStyles"
                       class="color-item"
                       [class.color-selected]="isStyleSelected(style.ID)"
                       (click)="selectStyle(style)">
                    <div class="color-box" [style.background-color]="'#' + style.HtmlColor1">
                      <i class="fa fa-check" *ngIf="isStyleSelected(style.ID)"></i>
                    </div>
                    <span class="color-label">{{ style.Name }}</span>
                  </div>
                </div>
              </div>

              <!-- Base Price -->
              <div class="info-group">
                <h4 class="section-title">Base Price</h4>
                <span class="price-value">${{ product.UnitCost | number:'1.2-2' }}</span>
              </div>

              <!-- Editor Button (commented out for now) -->
              <!-- <div class="info-group">
                <button mat-stroked-button class="btn-editor" (click)="openEditor()">
                  <mat-icon>brush</mat-icon>
                  Open Design Editor
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading state -->
  <div class="loading-state" *ngIf="!product">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
    <p>Loading product...</p>
  </div>

  <!-- Footer Actions -->
  <div class="footer-actions" *ngIf="product">
    <div class="footer-summary">
      <strong>1</strong> product selected for editing
    </div>
    <div class="footer-buttons">
      <button mat-stroked-button (click)="goBack()" class="btn-secondary">
        <mat-icon>arrow_back</mat-icon>
        Back to Products
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="continueToColorSelection()"
        class="btn-continue">
        Continue to Color Selection
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </div>
</div>
</div>

<!-- Editor Modal -->
<div class="editor-modal-overlay" *ngIf="showEditorModal" (click)="closeEditor()">
  <div class="editor-modal-content" (click)="$event.stopPropagation()">
    <div class="editor-modal-header">
      <h3>Edit Design - {{ editorProductName }}</h3>
      <button class="save-close-btn" (click)="closeEditor()" style="background: #4caf50; color: #fff; border: none; font-size: 14px; cursor: pointer; padding: 6px 16px; border-radius: 4px; font-weight: 500;">Save & Close</button>
    </div>
    <div class="editor-modal-body">
      <div *ngIf="isCreatingProject" class="editor-loading">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
        <p>Loading editor...</p>
      </div>
      <div id="dh-edit-editor-container" style="width: 100%; height: 600px;"></div>
    </div>
  </div>
</div>
